import { useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useScreenGo = () => {
  const _ref = useRef(null);
  const navigate = useNavigate();
  const { search } = useLocation();
  _ref.current = { navigate, search };
  return (pathname, options) => {
    const to = `${pathname}${_ref.current.search}`;

    return _ref.current.navigate(to, options);
  };
};

export default useScreenGo;
